import { MessageType } from '../../enums/message-type';
import { WebViewMessage } from './web-view-message';

export class RedirectCurrentViewMessage extends WebViewMessage {
  public constructor(public url: string | undefined) {
    super(MessageType.RedirectCurrentView);
  }
}
